import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getInscriptosTaller } from 'services/servicioGet';
import { UsuarioBase } from 'utils/models/types';

interface UsuariosState {
  inscriptos: UsuarioBase[];
  loadingInscriptos: boolean;
  errorInscriptos: string | null;
}
// Estado inicial del slice
const initialState: UsuariosState = {
  inscriptos: [],
  loadingInscriptos: false,
  errorInscriptos: null,
};

export const fetchInscriptosTaller = createAsyncThunk<
  UsuarioBase[],
  number, // Id del taller
  { rejectValue: string }
>('talleres/fetchInscriptosTaller', async (id, thunkAPI) => {
  try {
    const response = await getInscriptosTaller(id.toString());
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue('Error al cargar los usuarios');
  }
});

// Slice de inscriptos a taller
const inscriptosTallerSlice = createSlice({
  name: 'inscriptos',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchInscriptosTaller.pending, state => {
        state.loadingInscriptos = true;
        state.errorInscriptos = null;
      })
      .addCase(fetchInscriptosTaller.fulfilled, (state, action) => {
        state.inscriptos = action.payload;
        state.loadingInscriptos = false;
      })
      .addCase(fetchInscriptosTaller.rejected, (state, action) => {
        state.loadingInscriptos = false;
        // Capturamos el mensaje de error que devolvió rejectWithValue
        state.errorInscriptos = action.payload as string;
      });
  },
});

export default inscriptosTallerSlice.reducer;
